import { AnimatePresence, motion } from 'framer-motion';
import './ImageLightbox.css';

/**
 * ImageLightbox
 * Pass the currently-open image's src (or null to keep it closed) and
 * an onClose handler. Click the backdrop, the close button, or press
 * outside the image to dismiss.
 */
export default function ImageLightbox({ src, onClose }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div
          className="lightbox-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
          onClick={onClose}
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
        >
          <button type="button" className="lightbox-close" aria-label="Close" onClick={onClose}>
            ×
          </button>
          <motion.img
            src={src}
            alt="Full size attachment"
            className="lightbox-img"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.95 }}
            onClick={(e) => e.stopPropagation()}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}